import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Step } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationStep extends React.Component {
  render() {
    const { children, item, push, hideSidebar, customProps } = this.props
    return (
      <Step
        {...customProps}
        {...{
          href: item.path,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        <div className="hide-below-tablet">
          {children ? children : item.content}
        </div>
      </Step>
    )
  }
}

NavigationStep = connect(mapStateToProps, mapDispatchToProps)(NavigationStep)
export default NavigationStep



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationStep.jsx